export const TYPES = {
    COLOR: 1,
    BRAND: 2,
}